// Copyright (c) 2022 by Move Closer

import { computed, ComputedRef, ref, Ref, watch } from '@vue/composition-api'

import { VideoProps } from '../../Video.contracts'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export interface UseHTMLVideoProvides {
  /**
   * Determines reference for video element.
   */
  video: Ref<HTMLVideoElement | undefined>
  /**
   * Determines the video type to bind for `type` attr.
   */
  videoType: ComputedRef<string>
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const useHTMLVideo = (props: VideoProps): UseHTMLVideoProvides => {
  const video = ref<HTMLVideoElement | undefined>(undefined)

  /**
   * @see UseHTMLVideoProvides.videoType
   */
  const videoType = computed<string>(() => {
    return `video/${props.source.slice((Math.max(0, props.source.lastIndexOf('.')) || Infinity) + 1)}`
  })

  /**
   * Watches for changes of isVideoPlaying
   */
  watch<boolean>(() => props.isPlaying, (value, oldValue) => {
    if (value === oldValue && !value) {
      return
    }

    if (typeof video.value === 'undefined') {
      throw new Error('useHtmlVideo(): Video element is not found!')
    }

    video.value.play()
  })

  return { videoType, video }
}
